export default function tableBasicSearch() {
	const attr = "js-table-search"
	const els = document.querySelectorAll(`[${attr}]`)
	const url = new URL(window.location)
	let filtersOBJ = GLOBAL.splitFilters(url.search)


	if (!els.length) return


	els.forEach(i => {

		const wrapper = i.closest(".input-container")
		const btn = wrapper.querySelector("button")
		const btnClear = i.nextElementSibling
		
		btnClear.addEventListener('click', () => {
			filtersOBJ = {}

			const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ)
			window.location.href = `${url.origin}${url.pathname}${newFilters}`
		})
		
		btn.addEventListener("click", search(i))
		i.addEventListener("keyup", (e) => {
			showBtnClearFilter(i, btnClear)
		})


		// if (!filtersOBJ) return
		// if (filtersOBJ["filter"]) {
		// 	i.value = filtersOBJ["filter"]
		// } else {
		// 	return
		// }
	})


	function search(input) {
		return (e) => {
			const target = e.currentTarget
			const btnClear = input.nextElementSibling
			
			showBtnClearFilter(input, btnClear)
		
			if (filtersOBJ) {
				filtersOBJ["filter"] = input.value

			} else {
				filtersOBJ = {}
				filtersOBJ["filter"] = input.value
			}

			const newFilters = GLOBAL.generateStringFilterFromObject(filtersOBJ)
			window.location.href = `${url.origin}${url.pathname}${newFilters}`

		

		}
	}

	function showBtnClearFilter(input, btn){
		if(input.value != ""){
			btn.classList.remove('hidden')
		}else{
			btn.classList.add('hidden')
		} 
	}

}